"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = CyberSecurityCard;
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
require("./CyberSecurityCard.css");
/** Rady bezpieczenstwa pokazywane po jednej naraz. Tresc uzgodniona z wlascicielem:
 * rada o adresie nadawcy i o pospiechu wynika ze sprawy z podszyciem pod kontrahenta,
 * dlatego sa sformulowane bez nazywania konkretnej umowy. */
const tips = [
    {
        title: "Sprawdzaj pełny adres nadawcy",
        text: "Podszycie polega na tym, że nazwa firmy się zgadza, a domena różni się jedną literą albo końcówką. Rozwiń adres nadawcy i przeczytaj go w całości.",
    },
    {
        title: "Pośpiech to sygnał ostrzegawczy",
        text: "Im większa presja czasu, tym staranniej weryfikuj. Oszust liczy na to, że nie zdążysz sprawdzić.",
    },
    {
        title: "Uważaj na fałszywe powiadomienia o skrzynce",
        text: "Nasz serwer pocztowy nie wysyła wiadomości o zapełnieniu skrzynki. Informacje dotyczące serwera pocztowego możesz otrzymać wyłącznie od pracownika ENVI, który nim zarządza.",
    },
    {
        title: "Na podejrzaną wiadomość nie odpowiadaj",
        text: "Przycisk Odpowiedz wysyła list z powrotem do oszusta, bo to on ustawia adres zwrotny. Napisz nową wiadomość na adres, który masz w kontaktach, albo po prostu zadzwoń.",
    },
    {
        title: "Pocztę otwieraj tylko pod właściwym adresem",
        text: (react_1.default.createElement(react_1.default.Fragment, null,
            "Poprawne adresy to",
            " ",
            react_1.default.createElement("a", { href: "https://envi.com.pl/webmail", target: "_blank", rel: "noreferrer" }, "envi.com.pl/webmail"),
            " ",
            "oraz",
            " ",
            react_1.default.createElement("a", { href: "https://envi.com.pl/roundcube", target: "_blank", rel: "noreferrer" }, "envi.com.pl/roundcube"),
            ". Mo\u017Cna te\u017C korzysta\u0107 z klienta pocztowego, na przyk\u0142ad Outlooka.")),
    },
    {
        title: "Strona roundcube.pl to nie nasza poczta",
        text: (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("span", { className: "fw-semibold text-danger" }, "Nigdy si\u0119 tam nie loguj."),
            " Wpisane tam has\u0142o trafia w cudze r\u0119ce. Je\u017Celi logowa\u0142e\u015B si\u0119 tam wcze\u015Bniej, zmie\u0144 has\u0142o do poczty od razu.")),
    },
];
/** Minimalna wysokosc obszaru tresci. Dobrana pod najdluzsza rade, zeby przelaczanie
 * rad nie zmienialo wysokosci kafelka. */
const TIP_AREA_MIN_HEIGHT = 140;
function CyberSecurityCard({ className, style }) {
    /** Kierunek wjazdu nowej rady: 1 to wejscie z prawej (rada nastepna),
     * -1 to wejscie z lewej (rada poprzednia). */
    const [{ index, direction }, setPosition] = (0, react_1.useState)(() => ({
        index: Math.floor(Math.random() * tips.length),
        direction: 1,
    }));
    const tip = tips[index];
    const move = (step) => setPosition((current) => ({
        index: (current.index + step + tips.length) % tips.length,
        direction: step > 0 ? 1 : -1,
    }));
    const goTo = (target) => setPosition((current) => ({ index: target, direction: target > current.index ? 1 : -1 }));
    return (react_1.default.createElement(react_bootstrap_1.Card, { className: className, style: style },
        react_1.default.createElement(react_bootstrap_1.Card.Body, null,
            react_1.default.createElement(react_bootstrap_1.Card.Title, { className: "mb-2", style: { fontWeight: 600, fontSize: 18 } }, "Cyberbezpiecze\u0144stwo ENVI"),
            react_1.default.createElement("div", { className: "d-flex flex-column justify-content-center text-center", style: { minHeight: TIP_AREA_MIN_HEIGHT } },
                react_1.default.createElement("div", { key: index, className: `cyber-security-tip ${direction > 0 ? "from-right" : "from-left"}` },
                    react_1.default.createElement("div", { className: "fw-semibold small mb-1" }, tip.title),
                    react_1.default.createElement("div", { className: "text-secondary small" }, tip.text))),
            react_1.default.createElement("div", { className: "d-flex justify-content-between align-items-center mt-2" },
                react_1.default.createElement("button", { type: "button", className: "cyber-security-nav", onClick: () => move(-1), "aria-label": "Poprzednia rada" },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faChevronLeft, size: "sm" })),
                react_1.default.createElement("div", { className: "d-flex align-items-center", style: { gap: 6 } }, tips.map((item, itemIndex) => (react_1.default.createElement("button", { key: item.title, type: "button", className: `cyber-security-dot${itemIndex === index ? " active" : ""}`, onClick: () => goTo(itemIndex), "aria-label": `Rada ${itemIndex + 1}`, "aria-current": itemIndex === index })))),
                react_1.default.createElement("button", { type: "button", className: "cyber-security-nav", onClick: () => move(1), "aria-label": "Nast\u0119pna rada" },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faChevronRight, size: "sm" }))))));
}
